import * as React from 'react';

import styled, { css } from 'styled-components';

import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';

export type BoxSelectorStatusType = 'primary' | 'secondary' | 'selected';
export type BoxSelectorType = '' | 'company';

export interface BoxSelectorProps {
  className?: string;
  children?: any;
  status?: BoxSelectorStatusType;
  type?: BoxSelectorType;
  onClick?: () => void;
  decoration?: React.ReactElement;
}

const WrapperText = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-direction: column;
`;

export const BoxSelector: React.FC<BoxSelectorProps> = (props) => (
  <div
    className={props.className}
    onClick={() => (props.onClick ? props.onClick() : null)}
  >
    <WrapperText>
      {props.decoration ? (
        <div className="decoration">{props.decoration}</div>
      ) : null}
      <Typography className="item-title" weight="700">
        {props.children}
      </Typography>
      <Typography className="item-text" type="small">
        {props.status === 'primary' ? (
          <Translate id="ARTIST_PROFILE.PRESETS.GENRE.PRIMARY" />
        ) : null}
        {props.status === 'secondary' ? (
          <Translate id="ARTIST_PROFILE.PRESETS.GENRE.SECONDARY" />
        ) : null}
      </Typography>
    </WrapperText>
  </div>
);

export default styled(BoxSelector)`
  border-radius: ${({ theme }) => theme.general.borderRadius};
  background-color: ${({ theme }) => theme.colors.differentBackground};
  height: ${(props) => (props.decoration ? 'auto' : '64px')};
  min-width: 112px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  .item-text {
    opacity: 0.7;
    margin-top: 3px;
  }

  .decoration {
    margin-bottom: 12px;
  }

  ${(props) =>
    props.decoration
      ? css`
          padding: 16px 4px;
        `
      : null}

  ${(props) =>
    props.type === 'company'
      ? css`
          &.active {
            background-color: ${({ theme }) => theme.colors.primary};
          }
        `
      : null}

  ${(props) =>
    !props.status
      ? css`
          &:hover {
            background-color: ${({ theme }) => theme.colors.secondaryHover};
          }
        `
      : null}

  ${(props) =>
    props.status === 'primary'
      ? css`
          background-color: ${({ theme }) => theme.colors.primary};

          .item-title,
          .item-text {
            color: ${({ theme }) => theme.colors.background};
          }
        `
      : null}

  ${(props) =>
    props.status === 'secondary' || props.status === 'selected'
      ? css`
          background-color: ${({ theme }) => theme.colors.secondary};

          .item-title,
          .item-text {
            color: ${({ theme }) => theme.colors.primary};
          }
        `
      : null}
`;
